module.exports = __webpack_public_path__ + "static/media/main.17eafac7.png";